import React from 'react';
import { motion } from 'framer-motion';
import { DollarSign, Utensils } from 'lucide-react';

interface BabyMenuOptionsProps {
  maxPrice: number;
  courseCount: number;
  onUpdateMaxPrice: (price: number) => void;
  onUpdateCourseCount: (count: number) => void;
}

export const BabyMenuOptions: React.FC<BabyMenuOptionsProps> = ({
  maxPrice = 20,
  courseCount = 1,
  onUpdateMaxPrice,
  onUpdateCourseCount
}) => {
  return (
    <div className="bg-white rounded-lg p-4 mt-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
            <DollarSign className="text-pink-500" size={16} />
            Presupuesto máximo: {maxPrice}€
          </label>
          <input
            type="range"
            min={5}
            max={50}
            step={1}
            value={maxPrice}
            onChange={(e) => onUpdateMaxPrice(Number(e.target.value))}
            className="w-full h-2 bg-pink-200 rounded-lg appearance-none cursor-pointer accent-pink-500"
          />
          <div className="flex justify-between text-xs text-gray-500 mt-1">
            <span>5€</span>
            <span>50€</span>
          </div>
        </div>

        <div>
          <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
            <Utensils className="text-pink-500" size={16} />
            Número de platos
          </label>
          <div className="flex gap-2">
            {[1, 2, 3].map((count) => (
              <motion.button
                key={count}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => onUpdateCourseCount(count)}
                className={`flex-1 py-2 px-4 rounded-lg transition-all ${
                  courseCount === count
                    ? 'bg-pink-500 text-white shadow-md'
                    : 'bg-pink-100 text-gray-700 hover:bg-pink-200'
                }`}
              >
                {count} {count === 1 ? 'plato' : 'platos'}
              </motion.button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};